<form>
    <!-- Modal Header -->
    <div class="modal-header">
        <h4 class="modal-title">Select Approved Ticket</h4>
        <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
    </div>

    <div class="modal-body">
        <div class="container-fluid p-0">
            @if(approvedTicketList.length>0){
            <table class="table">
                <thead>
                    <tr>
                        <th>Ticket Number</th>
                        <th>Customer Details</th>
                        <th>Approved On</th>
                        <th>Action</th>
                    </tr>
                </thead>


                @for (t of approvedTicketList; track $index) {
                <tbody>
                    <tr>
                        <td>
                            #{{t.ID}}
                        </td>
                        <td>{{t.CustomerName}} ({{t.CustomerIC}}) </td>
                        <td>{{t.ProcessedOn |date:'dd-MM-yyyy'}}</td>
                        <td><button class="btn"
                                [ngClass]="{ 'btn-warning': warningApprovedLoan(t)==true, 'btn-info':warningApprovedLoan(t)==false}"
                                type="
                                button" (click)="loadLoanGroupRequestAndSendParent(t)">Use
                                This</button></td>
                    </tr>
                </tbody>

                }


            </table>
            }
            @else{
            <p>There is no available ticket to be selected

            </p>
            }
        </div>
    </div>

</form>